import React from "react";

import * as C from "./Header.styles.js";

import Logo from "../../assets/images/LogoRota.jpeg"

const Header = () => {
    return (
        <C.HeaderContainer>
            <C.StoreInformation>
                <C.ImageStore src={Logo} alt="Logo do estabelecimento" />
                <C.NameStore>Bem-vindo(a) à Rota Pizzaria</C.NameStore>
            </C.StoreInformation>
        </C.HeaderContainer>
    );
}

export default Header;
